function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-36.1,427.9c4-9.5,6.3-19.8,6.3-30.9c0-11.1-2.4-21.4-6.3-30.9c-4-9.5-9.5-18.2-16.6-25.3c-7.1-7.1-15.8-12.7-25.3-17.4 c-9.5-4-19.8-6.3-30.9-6.3s-21.4,2.4-30.9,6.3c-9.5,4-18.2,10.3-25.3,17.4c-7.1,7.1-12.7,15.8-16.6,25.3s-6.3,19.8-6.3,30.9 c0,10.3,2.4,20.6,6.3,30.9c4,9.5,9.5,18.2,16.6,25.3c7.1,7.1,15.8,12.7,25.3,17.4c9.5,4,19.8,6.3,30.9,6.3s21.4-2.4,30.9-6.3 c9.5-4,18.2-10.3,25.3-17.4C-45.6,446.1-40.1,437.4-36.1,427.9z"
});

var SvgSwrpgForce = function SvgSwrpgForce(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgForce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-force.daad34c7.svg";
export { ForwardRef as ReactComponent };